var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 12.8983C3 7.98391 7.02944 4 12 4C16.9706 4 21 7.98391 21 12.8983V16H20.9906C20.9968 16.0944 21 16.1897 21 16.2857V16.7143C21 19.0812 19.0812 21 16.7143 21C15.7675 21 15 20.2325 15 19.2857V13.7143C15 12.7675 15.7675 12 16.7143 12C17.7576 12 18.7139 12.3728 19.4571 12.9925V12.8983C19.4571 8.82638 16.1185 5.52542 12 5.52542C7.88153 5.52542 4.54286 8.82638 4.54286 12.8983V12.9925C5.28609 12.3728 6.24236 12 7.28571 12C8.23249 12 9 12.7675 9 13.7143V19.2857C9 20.2325 8.23249 21 7.28571 21C4.91878 21 3 19.0812 3 16.7143V16.2857C3 16.1897 3.00316 16.0944 3.00937 16H3V12.8983Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphone);
export default __webpack_public_path__ + "static/media/headphone.ce3aff1677ca05f5b41daabda092efa1.svg";
export { ForwardRef as ReactComponent };